<!--*****************************************************************
  * Copyright (c) Certus Software, 2021.                            *
  *                                                                 *
  * This unpublished material is proprietary to Certus Software.    *
  * All rights reserved. The methods and techniques described       *
  * herein are considered confidential and/or trade secrets.        *
  * Reproduction or distribution, in whole or in part, is forbidden *
  * except by express written permission of Certus Software.        *
  *****************************************************************-->

<h1 mat-dialog-title>
  {{'app.cookie.enableTitle' | translate}}
</h1>
<div mat-dialog-content>
  {{'app.cookie.enableText1' | translate}}
  <br>
  {{'app.cookie.enableText2' | translate}}
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>
    {{'app.cookie.enableBtn' | translate}}
  </button>
</div>
